<mat-toolbar class="toolbar" fxLayout="row" fxLayoutAlign="space-between center">

    <ng-container *ngFor="let section of configuration.sections">

        <div *ngIf="section?.backButton">
            <ng-container *ngIf="!section.backButton?.content; else Content">
                <span mat-button [ngClass]="section.backButton.styles"
                    (click)="goToPreviousPage(section.backButton.route)">
                    <mat-icon class="arrowBack">arrow_back</mat-icon>
                </span>
            </ng-container>
        </div>
        
        <div *ngIf="section?.partner && partnerData$ | async as partner; else waitingLogoPartner">
            <div class="container-partners" fxLayout="row">
                <div class="partners" fxLayout="row" fxLayoutAlign="space-between center">
                    <img *ngIf="partner.imagen" [src]="partner.imagen" alt="Partner logo" width="170px" height="auto">
                    <hr *ngIf="partner.imagen">
                    <a href="#" style="padding-bottom:0"><img class="partner" [src]="logoReale" alt="Ingood reale logo" width="180px" height="auto"></a>
                </div>
            </div>
        </div>

        <ng-template #waitingLogoPartner>
            <div style="margin-left: 3rem;">
                <a href="#"><img class="partner" [src]="logoReale" alt="Ingood reale logo" width="180px" height="auto"></a>
            </div>
          </ng-template>

        <div *ngIf="section?.menu">
            <div class="buttons-menu">
                <div *ngFor="let route of allowedRoutes">
                    <a *ngIf="route.title" mat-button [ngClass]="{'active-link': actualRoute(route)}" [routerLink]="'/' + route.path" routerLinkActive="active-link">{{route.title}}</a>
                </div>
            </div>
        </div>

        <div *ngIf="section?.close">
            <p class="close" (click)="goToPreviousPage(section.close.close)">X</p>
        </div>

    </ng-container>
</mat-toolbar>
